/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import AccountTitleDetailListView from '../../view/pages/account_title/AccountTitleDetailListView'
import AccountTitleDetailsStore from '../../store/account_title/AccountTitleDetailsStore'
import AccountTitleDetailAction from '../../action/account_title_detail'

class AccountTitleDetailListContainer extends Component {
  static getStores() {
    return [AccountTitleDetailsStore]
  }

  static calculateState(prevState, props) {
    return {
      details: AccountTitleDetailsStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    AccountTitleDetailAction.fetchAccountTitleDetails()
  }

  render() {
    return AccountTitleDetailListView(this.state)
  }
}

export default withRouter(Container.create(AccountTitleDetailListContainer, { withProps: true }))
